import { CountryCodeEnum } from "../config/i18n-config";
import { markets } from "../config/market-config";
import MarketSelectorItem from "./MarketSelectorItem";

const nordicMarketCodes = [
  CountryCodeEnum.SE,
  CountryCodeEnum.NO,
  CountryCodeEnum.DK,
  CountryCodeEnum.FI,
];

const nordics = Object.values(markets).filter((market) =>
  nordicMarketCodes.includes(market.countryCode),
);
const europe = Object.values(markets)
  .filter((market) => !nordicMarketCodes.includes(market.countryCode))
  .sort((a, b) => a.countryName.localeCompare(b.countryName));

export default function MarketSelectorList() {
  return (
    <section className="">
      <ul className="grid grid-flow-row auto-rows-auto divide-y">
        {[...nordics, ...europe].map((market) => (
          <MarketSelectorItem key={market.countryCode} market={market} />
        ))}
      </ul>
    </section>
  );
}
